var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdsOpens(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2E6BE6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.765 40.0731C26.7523 40.3769 26.8852 40.57 27.1638 40.6523C27.4423 40.7346 27.6892 40.6808 27.9044 40.4909L30.1262 38.2501L32.5949 44.3838C32.6582 44.5358 32.7627 44.6434 32.9083 44.7067C33.0539 44.77 33.1963 44.7763 33.3355 44.7257L34.9307 44.061C35.0826 43.9977 35.1807 43.8933 35.225 43.7477C35.2694 43.6021 35.2535 43.4533 35.1776 43.3014L32.5569 37.2626L35.6713 37.0727C35.9751 37.06 36.184 36.9366 36.298 36.7024C36.4119 36.4682 36.3613 36.2308 36.1461 35.9903L28.0183 27.8055C27.8031 27.5903 27.5784 27.5302 27.3442 27.6251C27.11 27.7201 26.9929 27.9131 26.9929 28.2043L26.765 40.0731Z",
    fill: "#2E6BE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3999 28C36.3999 27.4845 36.8178 27.0667 37.3332 27.0667H42.9332C43.4487 27.0667 43.8666 27.4845 43.8666 28C43.8666 28.5154 43.4487 28.9333 42.9332 28.9333H37.3332C36.8178 28.9333 36.3999 28.5154 36.3999 28Z",
    fill: "#2E6BE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 19.6C27.4845 19.6 27.0667 19.1821 27.0667 18.6666L27.0667 13.0666C27.0667 12.5512 27.4845 12.1333 28 12.1333C28.5154 12.1333 28.9333 12.5512 28.9333 13.0666L28.9333 18.6666C28.9333 19.1821 28.5154 19.6 28 19.6Z",
    fill: "#2E6BE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8733 22.3531C33.5089 21.9886 33.5089 21.3976 33.8733 21.0331L37.8331 17.0734C38.1976 16.7089 38.7886 16.7089 39.1531 17.0734C39.5176 17.4378 39.5176 18.0288 39.1531 18.3933L35.1933 22.3531C34.8288 22.7176 34.2378 22.7176 33.8733 22.3531Z",
    fill: "#2E6BE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6665 28C18.6665 27.4845 18.2486 27.0667 17.7332 27.0667H12.1332C11.6177 27.0667 11.1998 27.4845 11.1998 28C11.1998 28.5154 11.6177 28.9333 12.1332 28.9333H17.7332C18.2486 28.9333 18.6665 28.5154 18.6665 28Z",
    fill: "#2E6BE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1933 22.3531C21.5578 21.9886 21.5578 21.3976 21.1933 21.0331L17.2335 17.0734C16.869 16.7089 16.2781 16.7089 15.9136 17.0734C15.5491 17.4378 15.5491 18.0288 15.9136 18.3933L19.8734 22.3531C20.2379 22.7176 20.8288 22.7176 21.1933 22.3531Z",
    fill: "#2E6BE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1933 33.6469C21.5578 34.0114 21.5578 34.6024 21.1933 34.9669L17.2335 38.9266C16.869 39.2911 16.2781 39.2911 15.9136 38.9266C15.5491 38.5622 15.5491 37.9712 15.9136 37.6067L19.8734 33.6469C20.2379 33.2824 20.8288 33.2824 21.1933 33.6469Z",
    fill: "#2E6BE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsOpens);
export default __webpack_public_path__ + "static/media/ads-opens.35e0ed80282504abb036f28521c7b06d.svg";
export { ForwardRef as ReactComponent };